import React, { useContext, useEffect, useState, useRef, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box } from '@mui/material';
import { Drawer, List, ListItem, ListItemIcon, ListItemText, Tooltip } from '@mui/material';
import { Link as RouterLink, useLocation } from 'react-router-dom';
import { AvatarMenu } from './AvatarMenu';
import Icon from '../../assets/images/Icon.png';
import Logo from '../../assets/images/LogoIcon.png';
import patient_menuItems from './patient_menuItems';
import partner_menuItems from './partner_menuItems';
import integrationDocs_menuItems from './IntegrationDocs_menuItems';
import { PartnerContext } from '../../lib/contexts';
import { ModeContext } from '../../lib/contexts/ModeContext';
import ShareLinkDialog from '../ShareLinkDialog/ShareLinkDialog';
import { ThemeContext } from '../../lib/contexts/ThemeContext';
import TangeloIcon from './MainMenuIcons/TangeloIcon.png';

export const MainMenu = ({ openMenu, setIsSidebarOpen, onHoverExpand = true }) => {
  const {
    state: { code: partnerCode, userRole, name: partnerName, ...partnerState },
  } = useContext(PartnerContext);
  const { state: modeState } = useContext(ModeContext);
  const [chosenMenuItems, setChosenMenuItems] = useState([]);
  const [showShareLinkDialog, setShowShareLinkDialog] = useState(false);
  const [openSubMenu, setOpenSubMenu] = useState(() => {
    const savedSubMenuState = localStorage.getItem('submenuOpen');
    return savedSubMenuState !== null ? JSON.parse(savedSubMenuState) : {};
  });
  const [isMobileView, setIsMobileView] = useState(window.innerWidth <= 768);

  const location = useLocation();
  const navigate = useNavigate();
  const {
    state: { darkMode },
  } = useContext(ThemeContext);

  // const partner = usePartner(partnerCode);
  // useEffect(() => {
  //   console.log('here is partnerContext: ', userRole);
  //   console.log('here is partnerCode: ', partnerCode);
  //   console.log('here is the partner: ', partner);
  // }, [partner]);

  // const logoData = partnerState ? {
  //   large: partnerState.logo_large_url,
  //   lightLarge: partnerState.logo_light_large_url,
  //   lightMedium: partnerState.logo_light_medium_url,
  //   lightSmall: partnerState.logo_light_small_url,
  //   medium: partnerState.logo_medium_url,
  //   small: partnerState.logo_small_url,
  // } : {};
  // console.log('here is logoData from MainMenu: ', logoData);
  // console.log('here is partnerState from MainMenu: ', partnerState);

  useEffect(() => {
    if (location.pathname.includes('/docs')) {
      setChosenMenuItems(integrationDocs_menuItems);
    } else {
      setChosenMenuItems(modeState.adminView ? partner_menuItems : patient_menuItems);
    }
  }, [location.pathname, modeState.adminView]);

  const [open, setOpen] = useState(() => {
    // On mobile, always start with menu closed
    if (isMobileView) {
      return false;
    }
    // On desktop, use saved state or fall back to openMenu prop
    const savedMenuState = localStorage.getItem('menuOpen');
    return savedMenuState !== null ? JSON.parse(savedMenuState) : openMenu;
  });

  const drawerRef = useRef(null);

  const handleClickOutside = (event) => {
    if (isMobileView && drawerRef.current && !drawerRef.current.contains(event.target)) {
      setOpen(false);
      setIsSidebarOpen(false);
    }
  };

  useEffect(() => {
    const handleResize = () => {
      if (open && isMobileView) {
        document.addEventListener('mousedown', handleClickOutside);
      } else {
        document.removeEventListener('mousedown', handleClickOutside);
      }
    };

    handleResize(); // Initial check
    window.addEventListener('resize', handleResize);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      window.removeEventListener('resize', handleResize);
    };
  }, [open, isMobileView]);

  // Close menu when switching to mobile view
  useEffect(() => {
    const handleViewportResize = () => {
      const newIsMobileView = window.innerWidth <= 768;
      setIsMobileView(newIsMobileView);
      if (newIsMobileView && open) {
        setOpen(false);
        setIsSidebarOpen(false);
      }
    };

    window.addEventListener('resize', handleViewportResize);
    return () => window.removeEventListener('resize', handleViewportResize);
  }, [open, setIsSidebarOpen]);

  useEffect(() => {
    localStorage.setItem('menuOpen', JSON.stringify(open));
  }, [open]);

  const handleToggleMenu = useCallback(() => {
    setOpen(!open);
    setIsSidebarOpen(!open);
  }, [open]);

  const handleClick = (slug) => {
    setOpenSubMenu((prevOpenSubMenu) => (prevOpenSubMenu === slug ? null : slug));
  };

  return (
    <>
      <Drawer
        id="main-menu"
        ref={drawerRef}
        variant="permanent"
        open={open}
        sx={{
          // width: open ? 260 : 56,
          flexShrink: 0,
          transition: 'width 300ms ease',
          '& .MuiDrawer-paper': {
            width: open ? 260 : 70,
            overflowX: 'hidden',
            transition: 'width 300ms ease',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          },
        }}
      >
        {open ? (
          <img
            src={open ? partnerState.logo_small_url || Logo : Icon}
            alt=""
            onClick={handleToggleMenu}
            style={{
              cursor: 'pointer',
              width: open ? 150 : 'auto',
              height: open ? 'auto' : 36,
              margin: open ? '20px auto 20px' : '10px auto 10px',
              display: open ? 'block' : 'inherit',
            }}
          />
        ) : (
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
            }}
          >
            <img
              src={TangeloIcon}
              alt="Tangelo Icon"
              onClick={handleToggleMenu}
              style={{
                width: '30px',
                height: '30px',
                cursor: 'pointer',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            />
            {/* <Divider
              sx={{
                width: '200%',
              }}
            /> */}
          </div>
        )}
        {/* <Divider id="main-menu-divider" style={{width: '200%'}}/> */}
        <List
          sx={{
            display: 'flex',
            flexDirection: 'column',
            // justifyContent: 'space-between',
            height: '100%',
            // maxHeight: modeState.adminView ? open ? 450 : '40%' : open ? 250 : '20%',
            // maxHeight: '50%',
            overflowY: 'auto',
            overflowX: 'hidden',
            marginLeft: '3px',
          }}
        >
          {chosenMenuItems
            .filter((item) => !item.disabled)
            .map((item, index, array) => (
              <React.Fragment key={item.slug || index}>
                <Tooltip
                  title={item.tooltip || item.text}
                  placement="right"
                  arrow
                >
                  <ListItem
                    button
                    component={item.path && !item.url ? RouterLink : 'a'}
                    to={item.path && !item.url ? item.path : null}
                    href={item.url ? item.url : `#${item.slug}`}
                    onClick={(e) => {
                      if (item.url) {
                        e.preventDefault();
                        window.open(item.url, '_blank');
                      } else if (item.slug === 'share-link') {
                        e.preventDefault();
                        setShowShareLinkDialog(true);
                      } else if (item.name === 'Dashboard') {
                        navigate('/dashboard');
                      } else if (!item.path && item.children) {
                        e.stopPropagation();
                        handleClick(item.slug);
                      }
                    }}
                  >
                    <ListItemIcon sx={{ color: darkMode ? 'white' : 'black', marginLeft: open ? 0 : '25%' }}>
                      {item.icon}
                    </ListItemIcon>
                    {open && (
                      <ListItemText
                        primary={item.text}
                        sx={{ fontFamily: 'Montserrat !important' }}
                      />
                    )}
                  </ListItem>
                </Tooltip>
                {/* {index < array.length - 1 && <Divider />} */}
              </React.Fragment>
            ))}
        </List>
        <Box
          sx={{
            display: 'flex',
            width: '100%',
            justifyContent: open ? 'center' : 'flex-start',
          }}
        >
          <AvatarMenu expanded={open} />
        </Box>
      </Drawer>

      {showShareLinkDialog && <ShareLinkDialog handleClose={() => setShowShareLinkDialog(false)} />}
    </>
  );
}; /*
.map((item, index, array) => {
              const showDivider =
                index < array.length - 1 &&
                item.category !== array[index + 1].category;

              const isActive = item.path
                ? location.pathname.includes(item.path)
                : item.href
                ? location.pathname.includes(item.href)
                : location.hash.includes(`#${item.slug}`);

              return (
                <React.Fragment key={item.slug || index}>
                  <Tooltip title={item.tooltip || item.text} placement="right" arrow>
                    <ListItem
                      button
                      component={item.path || item.slug === '/dashboard' ? RouterLink : 'a'}
                      to={item.path || item.slug === '/dashboard' ? item.path || '/dashboard' : null}
                      href={item.href ? item.href : `#${item.slug}`}
                      onClick={(e) => {
                        if (item.slug === 'share-link') {
                          e.preventDefault();
                          setShowShareLinkDialog(true);
                        } else if (!item.path && item.children) {
                          e.stopPropagation();
                          handleClick(item.slug);
                        }
                      }}
                      sx={{
                        backgroundColor: isActive ? 'rgba(0, 0, 0, 0.04)' : 'inherit',
                      }}
                    >
                      <ListItemIcon
                        sx={{
                          color: isActive ? 'primary.main' : 'action.active',
                          marginLeft: '17%',
                        }}
                      >
                        {item.icon}
                      </ListItemIcon>
                      {open && <ListItemText primary={item.text} />}
                      {open && item.children && (
                        <ListItemSecondaryAction>
                          <IconButton
                            edge="end"
                            onClick={(e) => {
                              e.stopPropagation();
                              handleClick(item.slug);
                            }}
                          >
                            {openSubMenu === item.slug ? <ExpandLess /> : <ExpandMore />}
                          </IconButton>
                        </ListItemSecondaryAction>
                      )}
                    </ListItem>
                  </Tooltip>
                  {open && item.children && (
                    <Collapse
                      in={openSubMenu === item.slug}
                      timeout="auto"
                      unmountOnExit
                      sx={{
                        maxHeight: 'none',
                        overflowY: 'auto',
                      }}
                    >
                      <List
                        component="div"
                        disablePadding
                        sx={{
                          maxHeight: 300,
                          overflowY: 'auto',
                        }}
                      >
                        {item.children.map((child, idx) => (
                          <ListItem
                            button
                            key={child.slug || idx}
                            component={RouterLink}
                            to={child.path}
                            sx={{
                              pl: 4,
                              backgroundColor: location.pathname.includes(child.path) ? 'rgba(0, 0, 0, 0.04)' : 'inherit',
                            }}
                          >
                            <ListItemIcon>{child.icon}</ListItemIcon>
                            {open && <ListItemText primary={child.text} />}
                          </ListItem>
                        ))}
                      </List>
                    </Collapse>
                  )}
                  {showDivider && <Divider />}
                </React.Fragment>
              );
            })}
              */
